/** @format */

import {Box, styled} from '@mui/material';

export const WidgetsGrid = styled(Box, {
  shouldForwardProp: prop => prop !== 'widgetsCount',
})<{widgetsCount: number}>(({theme, widgetsCount}) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: widgetsCount === 4 ? 'repeat(2, 1fr)' : 'repeat(6, 1fr)',

  [`${theme.breakpoints.down('sm')}`]: {
    gridTemplateColumns: '1fr',
  },
}));

export const WidgetContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'widgetsCount' && prop !== 'index',
})<{
  widgetsCount: number;
  index: number;
}>(({widgetsCount, index}) => ({
  gridColumn: widgetsCount === 5 ? (index < 2 ? 'span 3' : 'span 2') : 'span 1',
}));
